module.exports = __webpack_public_path__ + "static/img/step3.17f97efc.png";